// extracted by mini-css-extract-plugin
module.exports = {"button":"EvaluationButton_button__1VWmW","isSelect":"EvaluationButton_isSelect__3AAwn"};